



































































import { Component, Mixins } from 'vue-property-decorator'
import UserAvatar from '@/components/users/UserAvatar.vue'
import { authenticationNamespace } from '@/store/authentication.store'
import { User } from '@/model/user'
import { authService } from '@/services/invite/authService'
import ComplexBackgroundContainer from '@/components/layouts/ComplexBackgroundContainer.vue'
import TabPageMixin from '@/mixins/tab-page-mixin'

@Component({
  name: 'more-actions',
  components: { ComplexBackgroundContainer, UserAvatar }
})
export default class MoreActions extends Mixins(TabPageMixin) {
  @authenticationNamespace.Getter('getUser')
  user!: User

  @authenticationNamespace.Getter('isProfileComplete')
  isProfileComplete!: boolean

  async logout (): Promise<void> {
    await authService.logout()
  }
}
